import { useLocation } from 'react-router-dom';
import { EProfileTabName } from 'types/ui/ProfileTabs/profile-tab-name.type';

export const useActiveTabValue = (): EProfileTabName => {
  const location = useLocation();
  const locationPartsList = location.pathname.split('/');
  return locationPartsList[locationPartsList.length - 1] as EProfileTabName;
};
